import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin, Subscription } from 'rxjs';
import { filter, take, map } from 'rxjs/operators';

import { ScheduleService } from '../../services/schedule.service';
import { UserService } from '../../services/user.service';
import { MixpanelService } from '@app/core/services';
import {
    IWizardConfig,
    IWizardSkill,
    IWizardMetaData,
    IWizardSchema,
    IWizardUser,
    IWizardAction,
    IDefaultWizardOptions
} from 'common-lib';
import { IAllNamedTypes, IUser } from '@app/core/interfaces';
import { ContactService } from '../../services/contact.service';
import { IContextContactInfo } from '@ext-interfaces/context.model';
declare var $: any;
@Component({
    selector: 'app-schedule',
    templateUrl: './schedule.component.html',
    styleUrls: ['./schedule.component.scss'],
    providers: [ScheduleService]
})
export class ScheduleComponent implements OnInit, OnDestroy {
    public wizardTask: IWizardSkill;
    public wizardMetaData: IWizardMetaData = {};
    public taskId = '';
    public meeting: IDefaultWizardOptions;
    public isFetchingTask = false;
    public meetingTypes: IAllNamedTypes[] = [];
    public isLoading = true;
    public wizardConfig: IWizardConfig = {
        taskId: '',
        skill: 'meeting-create-plugin',
        isPlugin: true,
        selectedMeetingType: 'meeting',
        componentsToHide: [],
        isScheduled: false,
    };
    public wizardUser: IWizardUser;
    private subscriptions = new Subscription();

    constructor(
        private scheduleService: ScheduleService,
        private userService: UserService,
        private mixpanelService: MixpanelService,
        private contactService: ContactService,
        private router: Router
    ) {}

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    ngOnInit() {
        this.subscriptions.add(this.addAndSetContextualContact());
        this.getSkillAndMeetingTypes();
    }

    private addAndSetContextualContact() {
        return this.contactService.contact.subscribe(async (contact?: IContextContactInfo) => {
            if (!contact) {
                return;
            }
            try {
                const addedContact = await this.contactService.addContact(contact.email, contact.name);

                this.wizardConfig = Object.assign(
                    {},
                    {
                        ...this.wizardConfig,
                        contactEmail: addedContact.defaultEmail
                    }
                );
            } catch (e) {
                this.showToast('error', `We were unable to add ${name} to your contacts.`);
                console.log(`Error saving contact: ${e}`);
            }
        });
    }

    private getSkillAndMeetingTypes() {
        const skill$ = this.scheduleService.getWizardSkill('meeting-create-plugin');
        const meetingTypes$ = this.scheduleService.getMeetingTypes();

        const user$ = this.userService.user$.pipe(
            filter((user) => !!user),
            take(1),
            map((user: IUser) => {
                return {
                    name: user.name,
                    avatar: user.avatar || 'Ava',
                    plan: user.plan,
                    timezone: user.timezone
                } as IWizardUser;
            })
        );

        forkJoin([skill$, meetingTypes$, user$]).subscribe((res) => {
            const [skill, meetingTypes, user] = res;

            this.wizardTask = skill.json;
            this.setWizardMetaData(skill);
            this.meetingTypes = meetingTypes.meetingTypeArray;
            this.wizardUser = user;

            this.isLoading = false;
        });
    }

    private setWizardMetaData(taskSchema: IWizardSchema) {
        if (!taskSchema.meta) return;
        this.wizardMetaData = taskSchema.meta;
    }

    public handleCancel() {
        this.router.navigate(['share']);
    }

    public handleTrackEvent(event: IWizardAction['mixpanel']) {
        this.mixpanelService.trackEvent(event.action, event.app, event.data, this.userService.user);
    }

    private showToast(type: 'error' | 'success', message: string) {
        $('body').toast({
            class: type,
            message
        });
    }
}
